<template>
  <div class="flex flex-column gap-3">
    <export-modal :visible.sync="visibleExportModal" :initial-section="initialExportSection"/>
    <compliance-sheet :visible.sync="visibleDocumentationModal" />

    <div class="flex justify-content-between align-items-start">
      <a-radio-group
        v-model="view"
        class="w-full"
        button-style="solid"
        data-testid="associate-profiles-filter-completion-status-radio"
      >
        <a-radio-button class="col-4 p-0 text-center" v-for="item in viewOptions" :key="item.value" :value="item.value">
          {{ item.label }}
        </a-radio-button>
      </a-radio-group>
    </div>

    <div class="flex justify-content-between align-items-start">
      <div class="flex gap-2">
        <uncompleted-task-action />
        <a-button icon="export" @click="openExportProfile()"> Export Profile </a-button>
        <a-button icon="export" @click="visibleDocumentationModal = true"> Export Compliance Sheet </a-button>
      </div>
      <a-input-search
        v-if="view === 'library'"
        :style="{ width: '300px' }"
        placeholder="Search document..."
        @search="onSearch"
        v-model="searchValue"
        size="small"
      />
    </div>

    <required-documents v-if="view === 'compliance'" mode="modal" :loading="complianceLoading" @open="$emit('open')" />
    <profile-lifecycle v-else-if="view === 'lifecycle'" />
    <template v-else>
      <documents-sign :search-value="searchProp" @click="handleLibraryEmptyLink" @export="openExportProfile('company_documents')"/>
      <documents-attach :search-value="searchProp" @click="handleLibraryEmptyLink" @export="openExportProfile('attached_documents')"/>
      <documentation
        :table="{
          title: 'On-/Off-boarding',
          data: onboarding,
          key: 'onboarding',
          loading
        }"
        :search-value="searchProp"
        @click="handleLibraryEmptyLink"
      />
    </template>
  </div>
</template>

<script>
import { Button, Input, notification, Radio } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'
import ProfileViewDocumentsAttach from './profile-view-documents-attach.vue'
import ProfileViewDocumentsSign from './profile-view-documents-sign.vue'
import ProfileViewDocumentation from './profile-view-documentation.vue'
import ProfileViewExport from './profile-view-export.vue'
import ProfileViewExportDocumentation from './profile-view-export-documentation.vue'
import ProfileViewRequiredDocuments from './required-documents/required-documents.vue'
import ProfileViewLifecycle from './lifecycle/lifecycle.vue'
import ProfileUncompletedTaskAction from './profile-uncompleted-task-action.vue'

const { mapState: profileState } = createNamespacedHelpers('profile')
const { mapState: sequenceState, mapActions: sequenceActions } = createNamespacedHelpers('sequence')

export default {
  name: 'ProfileViewDocuments',
  components: {
    'a-button': Button,
    'a-input-search': Input.Search,
    'a-radio-group': Radio.Group,
    'a-radio-button': Radio.Button,
    'documents-attach': ProfileViewDocumentsAttach,
    'documents-sign': ProfileViewDocumentsSign,
    documentation: ProfileViewDocumentation,
    'export-modal': ProfileViewExport,
    'compliance-sheet': ProfileViewExportDocumentation,
    'required-documents': ProfileViewRequiredDocuments,
    'profile-lifecycle': ProfileViewLifecycle,
    'uncompleted-task-action': ProfileUncompletedTaskAction
  },
  props: {
    complianceLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchValue: undefined,
      searchProp: undefined,
      view: 'compliance',
      loading: false,
      visibleExportModal: false,
      initialExportSection: null,
      visibleDocumentationModal: false,
      viewOptions: [
        { value: 'compliance', label: 'Compliance' },
        { value: 'lifecycle', label: 'Lifecycle' },
        { value: 'library', label: 'Library' }
      ]
    }
  },
  computed: {
    ...profileState({
      associate: state => state.associate
    }),
    ...sequenceState({
      onboarding: state => [
        ...(state.completedAssociateSequence.onboarding || []),
        ...(state.completedAssociateSequence.orientation || []),
        ...(state.completedAssociateSequence.departure || [])
      ]
    })
  },
  methods: {
    ...sequenceActions(['getAllCompletedSequence']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    onSearch() {
      this.searchProp = this.searchValue
    },

    handleLibraryEmptyLink() {
      this.view = 'library'
    },

    async loadOnboarding() {
      this.loading = true

      try {
        const promises = ['onboarding', 'orientation', 'departure'].map(item =>
          this.getAllCompletedSequence({
            associate_id: this.associate.id,
            sequence_type: item
          })
        )

        await Promise.all(promises)
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      } finally {
        this.loading = false
      }
    },
    openExportProfile(section = null) {
      this.initialExportSection = section
      this.visibleExportModal = true
    },
  },
  async mounted() {
    await this.loadOnboarding()
  }
}
</script>

<style scoped>
.profile-documents-view-switcher {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
